module.exports = __webpack_public_path__ + "img/sub18.188d54c7.jpg";